import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThreeDots } from 'react-loader-spinner';
import { Field, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import OtpInput from '../../components/otp-input/OtpInput';
import CommonButton from '../../components/common-button/CommonButton';
import PasswordInput from '../../components/common-inputs/PasswordInput';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import WithError from '../../components/with-error/WithError';
import CommonButtonLink from '../../components/common-button-link/CommonButtonLink';

import scss from '../Security.module.scss';

const OtpForm = ({ handleSubmit, onResendEmail }) => {
  const { t } = useTranslation('securityPage');
  const { valid } = useFormState();
  const { isLoading, isLoginOtp } = useSelector((state) => state.securityNew);

  return (
    <form className={scss.form} onSubmit={handleSubmit}>
      <h1 className={scss.title}>{t('securityCheck')}</h1>

      <div className={scss.items}>
        <h4 className={scss.subtitle}>{t('enter2FACode')}</h4>

        <Field name='otp'>
          {({ input, meta }) =>
            isLoginOtp ? (
              <OtpInput
                valueLength={6}
                disabled={isLoading}
                isError={!isLoading && meta.touched && meta.error}
                errorText={!isLoading && meta.touched && t(meta.error)}
                value={input.value}
                onChange={input.onChange}
                onBlur={input.onBlur}
                isDigit
              />
            ) : (
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <PasswordInput
                  placeholder={t('enterOtpCode')}
                  disabled={isLoading}
                  tabIndex={1}
                  formProps={input}
                  isError={meta.touched && meta.error}
                  LeftIcon={<Icon icon={ICONS.Lock} />}
                />
              </WithError>
            )
          }
        </Field>
      </div>

      <div className={scss['buttons--row']}>
        <CommonButton styleColor='primary' tabIndex={2} type='submit' maxWidth={190} disabled={!valid}>
          {isLoading ? <ThreeDots height={15} width={40} /> : null}
          {t('verify')}
        </CommonButton>

        <CommonButtonLink onClick={onResendEmail} tabIndex={3} type='reset' disabled={isLoading}>
          {t('sendAgain')}
        </CommonButtonLink>
      </div>
    </form>
  );
};

export default OtpForm;
